module.exports = __webpack_public_path__ + "static/media/calendar-icon.2a08bb86.svg";